import { FormControl, FormGroup } from "@angular/forms";
import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";

import { FormSearchParametersModel } from "../models/form-search-parameters.model";

export class SearchForm extends BaseObservableForm<FormSearchParametersModel> {
    public static createForm(initialSearchParams: FormSearchParametersModel): SearchForm {
        const formGroup = new FormGroup({
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            pageId: new FormControl<number>(initialSearchParams.pageId),
            searchText: new FormControl<string>(initialSearchParams.searchText),
            location: new FormControl<string>(initialSearchParams.location),
            gender: new FormControl<string>(initialSearchParams.gender),
            drivingLicence: new FormControl<boolean>(initialSearchParams.drivingLicence),
            workingRelationship: new FormControl<string>(initialSearchParams.workingRelationship)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageNumber")) as FormControl<number>; }
    public get pageId(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageId")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("searchText")) as FormControl<string>; }
    public get location(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("location")) as FormControl<string>; }
    public get gender(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("gender")) as FormControl<string>; }
    public get drivingLicence(): FormControl<boolean> { return this.formInstance.get(nameof<FormSearchParametersModel>("drivingLicence")) as FormControl<boolean>; }
    public get workingRelationship(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("workingRelationship")) as FormControl<string>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: FormSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText,
            location: this.initialFormState.location,
            jobType: this.initialFormState.gender,
            fromDate: this.initialFormState.drivingLicence,
            toDate: this.initialFormState.workingRelationship
        });
    }

    public searchByFilters(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1
        });
    }
}
